import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import type { BlueprintAspirationsCategories } from '@backrs_ui/grow-ui/src/redux/blueprint/blueprint.lubav.api';

export const useAgentContext = (categories: BlueprintAspirationsCategories | null | undefined) => {
  useRegisterAgentContext({
    kind: 'visual',
    label: 'Summary of Life Aspirations',
    display:
      "Grid of 8 aspiration category cards showing LLM-generated one-sentence summaries of the user's quiz answers: Lifestyle & Home, Work Settings, Sources of Meaning, Locations & Options, Career Attributes, Activities, Family & Caregiving, Building Wealth.",
    data: {
      lifestyleAndHome: categories?.lifestyle_and_home ?? null,
      workSettings: categories?.work_settings ?? null,
      sourcesOfMeaning: categories?.sources_of_meaning ?? null,
      locationsAndOptions: categories?.locations_and_options ?? null,
      careerAttributes: categories?.career_attributes ?? null,
      activities: categories?.activities ?? null,
      familyAndCaregiving: categories?.family_and_caregiving ?? null,
      buildingWealth: categories?.building_wealth ?? null,
    },
  });
};
